import { Link } from "gatsby"
import React from "react"
import { AnchorLink } from "gatsby-plugin-anchor-links";
import { Row, Col } from "react-bootstrap"
import Logo from "../images/logo.svg"

const Footer = () => (
  <footer className="footer">
    <div className="px-0">
      <Row>
        <Col lg="4" md="12" className="footer-col logo-col mb-4 mb-lg-0">
          <Link id="footer-logo-link" to="/"><img src={Logo} alt="ScrapeOwl logo" id="footer-logo" /></Link>

          <span>
            <strong style={{ fontSize: "1rem" }}>ScrapeOwl</strong> <br /><span id="smol">Simple and affordable web scraping API</span>
          </span>
        </Col>

        <Col lg="3" md="3" className="footer-col mb-4 mb-lg-0">
          <h4>Product</h4>

          <ul className="list-unstyled">
            <li>
              <AnchorLink to="/#features">
                Features
              </AnchorLink>
            </li>
            <li>
              <Link to="/pricing">
                Pricing
              </Link>
            </li>
            <li>
              <Link to="/docs">
                Docs
              </Link>
            </li>

          </ul>
        </Col>

        <Col lg="3" md="3" className="footer-col mb-4 mb-lg-0">
          <h4>Company</h4>

          <ul className="list-unstyled">
            <li>
              <Link to="/team">
                Team
              </Link>
            </li>
            {/* <li>
              <Link to="/open-work">
                Work
              </Link>
            </li> */}
            <li>
              <a href="mailto:team@scrapeowl.com">
                Contact us
              </a>
            </li>
            {/* <li>
              <Link to="/docs">
              Work with us
              </Link>
            </li> */}
          </ul>
        </Col>

        <Col lg="2" md="3" className="footer-col">
          <h4>Quick Links</h4>

          <ul className="list-unstyled">
            {/* <li>
              <Link to="/docs">
                Blog
              </Link>
            </li> */}
            <li>
              <a href="https://t.me/joinchat/Jhr2g1YqB9E2BRNiOcPGVQ">
                Chat
              </a>
            </li>
            <li>
              <a href="mailto:support@scrapeowl.com">
                Support
              </a>
            </li>

          </ul>
        </Col>

        {
          /*
          <Col lg="2" md="3" className="footer-col">
            <h4>Comparisons</h4>

            <ul className="list-unstyled">
              <li>
                <Link to="/scraperapi-alternative">
                  vs ScraperAPI
                </Link>
              </li>
              <li>
                <Link to="/scrapingbee-alternative">
                  vs ScrapingBee
                </Link>
              </li>
              <li>
                <Link to="/proxycrawl-alternative">
                  vs ProxyCrawl
                </Link>
              </li>
            </ul>
          </Col>
          */
        }


      </Row>

      <div className="trailing">

        <Col lg="12" md="12" id="relevant-trail">

          <div id="trail-container">
            <Col className="year-container" lg="4" md="4" sm="12" xs="12"><span id="footer-year">© {new Date().getFullYear()} all rights reserved.</span></Col>

            <Col className="list-container" lg="8" md="8" sm="12" xs="12" >
              <ul className="list-unstyled">
                <li>
                  <Link to="/terms">
                    Terms of Service
                </Link>
                </li>
                <li>
                  <Link to="/privacy">
                    Privacy Policy
                </Link>
                </li>
                <li>
                  <a href="mailto:support@scrapeowl.com">
                    Contact Support
                </a>
                </li>
                <li>
                  <Link to="/affiliates">
                    Affiliates
              </Link>
                </li>
              </ul>
            </Col>
          </div>
        </Col>
      </div>
    </div>
  </footer>
)

export default Footer
